export function canPurchasePattern(pattern) {
  return pattern?.status === 'published'
    && Number.isFinite(Number(pattern?.price))
    && Number(pattern.price) > 0;
}
